import { EmailRegex } from '../../../utils/helpers/regex';
import { Errors, FormInput } from '../../../utils/types/login_register_types';

const UppercaseRegex = /[A-Z]/;
const NumericRegex = /[0-9]/;
const SpecialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

function validatePassword(value: string): string {
  if (value.length < 8) return 'Password must be at least 8 characters long!';
  if (value.length > 32) return 'Password must be no more than 32 characters long!';
  if (!UppercaseRegex.test(value)) return 'Password must contain at least 1 uppercase letter!';
  if (!NumericRegex.test(value)) return 'Password must contain at least 1 numeric character!';
  if (!SpecialCharRegex.test(value)) return 'Password must contain at least 1 special character!';
  return '';
}

export function validate(eventTarget: HTMLInputElement, formInputs: FormInput) {
  const { name, value } = eventTarget;
  const { password, confirmPassword, errors } = formInputs;

  if (name === 'email') {
    errors.emailError = EmailRegex.test(value) ? '' : 'Email is not valid!';
  } else if (name === 'password' && confirmPassword !== undefined) {
    errors.passwordError = validatePassword(value);
    errors.confirmPasswordError = value !== confirmPassword ? 'Passwords do not match!' : '';
  } else if (name === 'confirmPassword') {
    errors.confirmPasswordError = validatePassword(value);
    if (!errors.confirmPasswordError) {
      errors.confirmPasswordError = value !== password ? 'Passwords do not match!' : '';
    }
  }

  return errors;
}

export function validateForm(formInputs: FormInput) {
  let valid = true;
  const { errors } = formInputs;

  Object.values(errors).forEach((value: string) => {
    if (value !== undefined && value.length > 0) {
      valid = false;
    }
  });

  Object.values(formInputs).forEach((value: string | Errors) => {
    if (typeof value === 'string' && value.length === 0) {
      valid = false;
    }
  });

  return valid;
}
